import module from 'cheques/module.js'

module.directive('stringToNumber', () => ({
  require: 'ngModel',
  link: (scope, element, attrs, ngModel) => {
    ngModel.$parsers.push((value) => '' + value)
    ngModel.$formatters.push((value) => parseFloat(value))
  },
}))



// WEBPACK FOOTER //
// ./src/cheques/directives/string-to-number/directive.js